import { RvidCallType } from "../enums/rvid-call-type.enum";

export class RvidData implements IRvidData {
  $type: string="SampleCube.UserFlow.API.Models.SurveyPage.RelevantIdApiModel, SampleCube.UserFlow.API.Models.SurveyPage";
  RvidCallType: RvidCallType=RvidCallType.NoData;
  Score: number = null;
  GeoIP: number = null;
  TotalCompletes: number = null;
  FraudProfileScore: number = null;
  FraudRiskProbability:number=null;
  FraudFlagCount: number = null;
  isNew: boolean = null;
  CompleteFlag: boolean = null;
  ScreenoutFlag: boolean = null;
  FPF1: boolean = null;
  FPF2: boolean = null;
  FPF3: boolean = null;
  FPF4: boolean = null;
  FPF5: boolean = null;
  FPF6: boolean = null;
  FPF7: boolean = null;
  FPF8: boolean = null;
  FPF9: boolean = null;
  FPF10: boolean = null;
  FPF11: boolean = null;
  FPF12: boolean = null;
  FPF13: boolean = null;
  FPF14: boolean = null;
  isMobile: boolean = null;
  OldIDDate: Date = null;
  CompleteDate: Date = null;
  ScreenoutDate: Date = null;
  RVid: string = null;
  Country: string = null;
  OldId: string = null;
  CSOPanelistID: string = null;
  CSOPanelistIDDate: string = null;
  CSOPanelistIDStatus: string = null;
  Domain: string = null;
  RVIDHash2: string = null;

  constructor(options?: IRvidData) {
    options = options || {};
    for (const property in options) {
      if (property!=="$type" && options.hasOwnProperty(property) && this.hasOwnProperty(property)) {
        this[property] = options[property];
      }
    }
  }

  static getTypeOf(property: string): string {
    switch (property) {
      case "Score":
      case "GeoIP":
      case "TotalCompletes":
      case "FraudProfileScore":
      case "FraudRiskProbability":
      case "FraudFlagCount":
        return "number";
      case "isNew":
      case "CompleteFlag":
      case "ScreenoutFlag":
      case "FPF1":
      case "FPF2":
      case "FPF3":
      case "FPF4":
      case "FPF5":
      case "FPF6":
      case "FPF7":
      case "FPF8":
      case "FPF9":
      case "FPF10":
      case "FPF11":
      case "FPF12":
      case "FPF13":
      case "FPF14":
      case "isMobile":
        return "boolean";
      case "OldIDDate":
      case "CompleteDate":
      case "ScreenoutDate":
        return "Date";
      case "RVid":
      case "Country":
      case "OldId":
      case "CSOPanelistID":
      case "CSOPanelistIDDate":
      case "CSOPanelistIDStatus":
      case "Domain":
      case "RVIDHash2":
      default:
        return "string";
    }
  }
}

export interface IRvidData {
  $type?: string;
  RvidCallType?: RvidCallType;
  RVid?: string;
  IsNew?: boolean;
  Score?: number;
  GeoIP?: number;
  Country?: string;
  OldId?: string;
  OldIDDate?: Date;
  CompleteFlag?: boolean;
  CompleteDate?: Date;
  ScreenoutFlag?: boolean;
  ScreenoutDate?: Date;
  TotalCompletes?: number;
  CSOPanelistID?: string;
  CSOPanelistIDDate?: string;
  CSOPanelistIDStatus?: string;
  Domain?: string;
  FraudProfileScore?: number;
  FraudRiskProbability?:number;
  FPF1?: boolean;
  FPF2?: boolean;
  FPF3?: boolean;
  FPF4?: boolean;
  FPF5?: boolean;
  FPF6?: boolean;
  FPF7?: boolean;
  FPF8?: boolean;
  FPF9?: boolean;
  FPF10?: boolean;
  FPF11?: boolean;
  FPF12?: boolean;
  FPF13?: boolean;
  FPF14?: boolean;
  FraudFlagCount?: number;
  RVIDHash2?: string;
  IsMobile?: boolean;
}
